import React from "react";
import "./Loader.css";

const Loader = ({ message = "Please Wait..." }) => {
  return (
    <div className="global-loader-overlay">
      <div className="global-loader-box">
        <div className="global-loader-spinner">
          <div className="global-loader-spinner-inner"></div>
        </div>

        <p className="global-loader-message">
          {message}
        </p>
      </div>
    </div>
  );
};

export default Loader;